import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <section className="min-h-screen flex flex-col items-center justify-center text-center bg-gradient-to-br from-white to-yellow-100 px-4 py-20">
      <motion.img
        initial={{ scale: 0.8, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ duration: 0.8 }}
        src="/images/notfound.svg" // SVG illustration from undraw.co
        alt="404 Illustration"
        className="w-80 md:w-96 mb-10"
      />

      <motion.h1
        initial={{ y: -30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.6 }}
        className="text-4xl font-bold text-[#0E324C] mb-4"
      >
        404 - Page Not Found
      </motion.h1>

      <motion.p
        initial={{ y: 30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.5, duration: 0.6 }}
        className="text-gray-600 text-lg mb-8"
      >
        Oops! The page you're looking for doesn't exist or has been moved.
      </motion.p>

      <motion.button
        whileHover={{ scale: 1.05 }}
        onClick={() => navigate("/")}
        className="bg-[#0E324C] text-white px-6 py-3 rounded-xl font-medium hover:bg-[#092434] transition"
      >
        Go to Homepage
      </motion.button>
    </section>
  );
};

export default NotFoundPage;
